// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  padding: 20px;
  width: 100% !important;
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border-radius: 10px;
}
.calendar-container .events-style {
  color: white !important;
  border-radius: 5px !important;
  padding: 1px 10px !important;
  text-align: center;
  font-size: 10px;
  font-weight: 300 !important;
  border: 1px solid white !important;
  width: fit-content !important;
  margin-right: 5px !important;
}
.calendar-container .fc .fc-toolbar-title {
  font-size: 28px;
}
.calendar-container .fc-scrollgrid thead tr th div div table thead tr th {
  padding: 10px !important;
  align-items: center !important;
  justify-content: center !important;
}
.calendar-container .right-container .search-icon {
  position: absolute;
  left: 15px;
  top: 9px;
}
.calendar-container .right-container .inner {
  margin-left: 10px !important;
  background-color: rgba(200, 199, 250, 0.15);
}
.calendar-container .fc .fc-daygrid-event {
  cursor: pointer;
}
.calendar-container .fc-daygrid-event-dot {
  display: none !important;
}
.calendar-container .fc .fc-daygrid-day-top {
  justify-content: center;
  cursor: pointer;
}
.calendar-container .fc .fc-daygrid-day-events {
  margin-right: 5px !important;
  cursor: pointer;
}
.calendar-container .fc-scrollgrid thead {
  height: 50px !important;
  align-items: center;
}
.calendar-container .fc-scrollgrid thead tr th div div table thead tr th {
  padding: 10px;
}
.calendar-container .fc-toolbar-chunk {
  position: relative;
}
.calendar-container .fc-toolbar-chunk .fc-button-group .fc-button {
  background: none !important;
  border: none;
  color: black;
  font-size: larger;
  font-weight: 700;
}
.calendar-container .fc-toolbar-chunk .fc-button-group .fc-button:focus {
  box-shadow: none !important;
  color: black;
  font-weight: 900;
}
.calendar-container .fc-toolbar-chunk .fc-today-button {
  background: #ff611d !important;
  border: none;
  padding: 5px 25px;
  text-transform: capitalize;
  font-size: 12px;
}
.calendar-container .fc-toolbar-chunk .fc-Reminder-button {
  font-size: 12px;
  background: #ff611d !important;
  border: none;
  padding: 5px 25px;
}
.calendar-container .fc-toolbar-chunk .fc-Legends-button {
  position: absolute;
  bottom: -30%;
  left: 50%;
  font-size: 12px;
  background: #53b958 !important;
  border: none;
  padding: 10px;
}
.calendar-container .fc-toolbar-chunk .fc-Legends-button::after {
  position: absolute;
  top: 10%;
  left: 110%;
  content: "Reminders";
  color: #000000 !important;
}

.breakfast-bg {
  background-color: #03c5de !important;
}

.lunch-bg {
  background-color: #ff9800 !important;
}

.parties-bg {
  background-color: #f9483b !important;
}

.brunch-bg {
  background-color: #007bff !important;
}

.reminder-bg {
  background-color: #53b958 !important;
}

.dinner-bg {
  background-color: #333333 !important;
}

.breakfast-border {
  border: 2px solid #03c5de !important;
}

.lunch-border {
  border: 2px solid #ff9800 !important;
}

.parties-border {
  border: 2px solid #f9483b !important;
}

.brunch-border {
  border: 2px solid #007bff !important;
}

.reminder-border {
  border: 2px solid #53b958 !important;
}

.dinner-border {
  border: 2px solid #333333 !important;
}

.capitalize {
  text-transform: capitalize !important;
}

.my-calendar-dropdown-option-color:hover {
  background-color: #ff611d !important;
  border-radius: 10px;
  color: #ffffff;
  border-color: transparent;
}

.fc .fc-toolbar.fc-header-toolbar {
  gap: 20%;
  justify-content: flex-start;
  font-size: 24px;
  margin-bottom: 2.5em !important;
}

@media only screen and (max-width: 1536px) {
  .fc .fc-toolbar.fc-header-toolbar {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .calendar-container .events-style {
    width: 100% !important;
  }
}
@media only screen and (max-width: 700px) {
  .calendar-container .fc-scrollgrid thead tr th div div table thead tr th {
    font-size: smaller;
    padding: 0px !important;
  }
  .calendar-container .fc-scrollgrid thead {
    height: 30px !important;
    align-items: center;
  }
  .calendar-container .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}
@media only screen and (max-width: 900px) and (min-width: 699px) {
  .legends {
    top: 25% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/calendar/my-calendar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wDAAA;EACA,mBAAA;AACF;AACE;EACE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,kCAAA;EACA,6BAAA;EACA,4BAAA;AACJ;AACE;EACE,eCqBe;ADpBnB;AAEE;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;AAAJ;AAII;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAFN;AAKI;EACE,4BAAA;EACA,2CAAA;AAHN;AAOE;EACE,eAAA;AALJ;AAQE;EACE,wBAAA;AANJ;AASE;EACE,uBAAA;EACA,eAAA;AAPJ;AAUE;EACE,4BAAA;EACA,eAAA;AARJ;AAYI;EACE,uBAAA;EACA,mBAAA;AAVN;AAYM;EACE,aAAA;AAVR;AAeE;EACE,kBAAA;AAbJ;AAgBM;EACE,2BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAdR;AAgBQ;EACE,2BAAA;EACA,YAAA;EACA,gBAAA;AAdV;AAmBI;EACE,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,eC7CW;AD4BjB;AAoBI;EACE,eCjDW;EDkDX,8BAAA;EACA,YAAA;EACA,iBAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eC3DW;ED4DX,8BAAA;EACA,YAAA;EACA,aAAA;AAnBN;AAqBM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;AAnBR;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA0BA;EACE,oCAAA;AAvBF;;AA2BA;EACE,oCAAA;AAxBF;;AA4BA;EACE,oCAAA;AAzBF;;AA6BA;EACE,oCAAA;AA1BF;;AA8BA;EACE,oCAAA;AA3BF;;AA+BA;EACE,oCAAA;AA5BF;;AAkCA;EACE,qCAAA;AA/BF;;AAmCE;EACE,oCAAA;EACA,mBAAA;EACA,cCrLU;EDsLV,yBAAA;AAhCJ;;AAoCA;EACE,QAAA;EACA,2BAAA;EACA,eC9JkB;ED+JlB,+BAAA;AAjCF;;AAoCA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAjCF;EAqCE;IACE,sBAAA;EAnCJ;AACF;AAuCA;EAGE;IACE,kBAAA;IACA,uBAAA;EAvCF;EAyCF;IACE,uBAAA;IACA,mBAAA;EAvCA;EA0CE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EAxCJ;AACF;AA4CA;EACE;IACE,mBAAA;EA1CF;AACF","sourcesContent":["@import \"../../styles/variables\";\n\n.calendar-container {\n  padding: 20px;\n  width: 100% !important;\n  background-color: white;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  border-radius: 10px;\n\n  .events-style {\n    color: white !important;\n    border-radius: 5px !important;\n    padding: 1px 10px !important;\n    text-align: center;\n    font-size: 10px;\n    font-weight: 300 !important;\n    border: 1px solid white !important;\n    width: fit-content !important;\n    margin-right: 5px !important;\n  }\n  .fc .fc-toolbar-title{\n    font-size: $tertiary-heading;\n  }\n\n  .fc-scrollgrid thead tr th div div table thead tr th {\n    padding: 10px !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .right-container {\n    .search-icon {\n      position: absolute;\n      left: 15px;\n      top: 9px;\n    }\n\n    .inner {\n      margin-left: 10px !important;\n      background-color: rgba(200, 199, 250, 0.15);\n    }\n  }\n\n  .fc .fc-daygrid-event {\n    cursor: pointer;\n  }\n\n  .fc-daygrid-event-dot {\n    display: none !important;\n  }\n\n  .fc .fc-daygrid-day-top {\n    justify-content: center;\n    cursor: pointer;\n  }\n\n  .fc .fc-daygrid-day-events {\n    margin-right: 5px !important;\n    cursor: pointer;\n  }\n\n  .fc-scrollgrid {\n    thead {\n      height: 50px !important;\n      align-items: center;\n\n      tr th div div table thead tr th {\n        padding: 10px;\n      }\n    }\n  }\n\n  .fc-toolbar-chunk {\n    position: relative;\n\n    .fc-button-group {\n      .fc-button {\n        background: none !important;\n        border: none;\n        color: black;\n        font-size: larger;\n        font-weight: 700;\n\n        &:focus {\n          box-shadow: none !important;\n          color: black;\n          font-weight: 900;\n        }\n      }\n    }\n\n    .fc-today-button {\n      background: $primary-color !important;\n      border: none;\n      padding: 5px 25px;\n      text-transform: capitalize;\n      font-size: $tertiary-title;\n    }\n \n    .fc-Reminder-button {\n      font-size: $tertiary-title;\n      background: $primary-color !important;\n      border: none;\n      padding: 5px 25px;\n    }\n\n    .fc-Legends-button {\n      position: absolute;\n      bottom: -30%;\n      left: 50%;\n      font-size: $tertiary-title;\n      background: #53b958 !important;\n      border: none;\n      padding: 10px;\n\n      &::after {\n        position: absolute;\n        top: 10%;\n        left: 110%;\n        content: 'Reminders';\n        color: $black-color !important;\n      }\n    }\n  }\n}\n\n\n.breakfast-bg {\n  background-color: #03c5de !important;\n}\n\n.lunch-bg {\n  background-color: #ff9800 !important;\n}\n\n.parties-bg {\n  background-color: #f9483b !important;\n}\n\n.brunch-bg {\n  background-color: #007bff !important;\n}\n\n.reminder-bg {\n  background-color: #53b958 !important;\n}\n\n.dinner-bg {\n  background-color: $secondary-color !important;\n}\n\n.breakfast-border {\n  border: 2px solid #03c5de !important;\n\n}\n\n.lunch-border {\n  border: 2px solid #ff9800 !important;\n\n}\n\n.parties-border {\n  border: 2px solid #f9483b !important;\n\n}\n\n.brunch-border {\n  border: 2px solid #007bff !important;\n\n}\n\n.reminder-border {\n  border: 2px solid #53b958 !important;\n\n}\n\n.dinner-border {\n  border: 2px solid $secondary-color !important;\n\n}\n\n//----------------------\n\n.capitalize {\n  text-transform: capitalize !important;\n}\n\n.my-calendar-dropdown-option-color {\n  &:hover {\n    background-color: $primary-color !important;\n    border-radius: 10px;\n    color: $white-color;\n    border-color: transparent;\n  }\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n  gap: 20%;\n  justify-content: flex-start;\n  font-size: $secondary-heading;\n  margin-bottom: 2.5em !important;\n}\n\n@media only screen and (max-width: 1536px) {\n  .fc .fc-toolbar.fc-header-toolbar {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .calendar-container {\n    .events-style {\n      width: 100% !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 700px) {\n  .calendar-container {\n\n  .fc-scrollgrid thead tr th div div table thead tr th {\n    font-size: smaller;\n    padding: 0px !important;\n}\n.fc-scrollgrid thead {\n  height: 30px !important;\n  align-items: center;\n}\n  .fc .fc-toolbar.fc-header-toolbar {\n    .fc-toolbar-chunk {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n  }\n}\n}\n@media only screen and (max-width:900px)and (min-width: 699px) {\n  .legends {\n    top: 25% !important;\n  }\n}","// all color, text-sizes, border-radius etc  should be initialize here as variables and use them in styling\n// do not write explicitly values.\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n//colors\n$primary-color: #ff611d;\n$secondary-color: #333333;\n\n$black-color: #000000;\n$white-color: #ffffff;\n$dark-gray-color: #3c3c3c;\n$grey-color: #747070;\n$orange-color: #ff8908;\n$yellow-color: #ffb80e;\n$link-color: #59a9ff;\n$orange-yellowish-color: #ffa412;\n$mid-green-color: #00d27a;\n$apple-green-color:#659c35;\n$dark-white-smoke-color: #f5f8fe;\n$mix-grey-color: linear-gradient(180deg, #464c52 0%, #464c5299 100%);\n$orange-color-300: #FFA300;\n\n$solitude-color:#E9EFFD;\n$error-color: #dc3545;\n$alert-text-color:#81222C;\n$success-color: #165c27;\n$alertgreen-color: #d0e7d6;\n$alertred-color:#F7D5D8;\n$selected-tap-color: #1c1b1b;\n$rate-star-color: #ffce31;\n$icon-color: #c4c4c4;\n$selected-field-color: #6c757d;\n$hover-color: #fee6dd;\n$blue_magenta_color: #EBEBEE;\n$green-color:#40d698;\n$light-gray-color:#9d99b9;\n$mid-gray: #676c70;\n\n//font-size\n$primary-heading: 32px;\n$secondary-heading: 24px;\n$tertiary-heading: 28px;\n$heading-48: 48px;\n$heading-42: 42px;\n$heading-20: 20px;\n$heading-22: 22px;\n$heading-18: 18px;\n\n$primary-title: 16px;\n$secondary-title: 14px;\n$tertiary-title: 12px;\n$title-15: 15px;\n$title-13: 13px;\n$title-10: 10px;\n\n//border-radius\n$border-radius-4: 4px;\n$border-radius-5: 5px;\n$border-radius-10: 10px;\n$border-radius-15: 15px;\n$border-radius-20: 20px;\n$border-radius-rounded:50%;\n\n//font-weight\n$font-weight-300: 300;\n$font-weight-400: 400;\n$font-weight-500: 500;\n$font-weight-600: 600;\n$font-weight-700: 700;\n$font-weight-800: 800;\n$font-weight-900: 900;\n\n//font-family\n$font-family-montserrat: \"Montserrat\", \"Roboto\", \"sans-serif\";\n$font-family-roboto: \"Roboto\", \"sans-serif\", \"Montserrat\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
